import { type TemplateSegment, parseTemplateSegments } from "@imminently/decisively-core";
import type { AttributeOption } from "./types";

/**
 * Parses a stored template against the attributes a control offers. Keys match
 * case-insensitively, like the renderers, and a segment takes the attribute's own
 * key. A reference to anything else is kept verbatim as text. The syntax itself
 * (formatters, `as "label"`, `@parent/...` migration) is core's `parseTemplateSegments`.
 */
export function parseAttributeTemplate(template: string, attributes: AttributeOption[]): TemplateSegment[] {
  const byKey = new Map(attributes.map((attribute) => [attribute.key.toLowerCase(), attribute.key]));
  return parseTemplateSegments(template, { resolveKey: (key) => byKey.get(key.trim().toLowerCase()) });
}
